import Link from "next/link";
import { Button } from "../ui/button";
import { ReactNode } from "react";
import { useTranslations } from "next-intl";

const Breadcrumb = ({
  pageName,
  breadcrumbName,
  description,
  bgImages = ["/images/header/BenefitsforEndUsers-slider-bg.webp"],
  bgIndex = 0,
  buttons = [], // array of button configs
  parentPage,
}: {
  pageName: string;
  breadcrumbName?: string;
  description: string;
  bgImages?: string[];
  bgIndex?: number;
  buttons?: { label: string; props?: any; icon?: ReactNode; href?: string }[];
  parentPage?: { label: string; href: string };
}) => {
  const bgImage = bgImages[bgIndex] || bgImages[0];

  const t = useTranslations("commonchange");
  return (
    <>
      <section className="relative z-10 overflow-hidden pb-4 md:pb-8">
        <div className="container rounded-tl-5xl rounded-br-5xl px-2 md:px-6">
          <div
            className="relative flex flex-col md:flex-row md:items-center md:justify-between rounded-tl-5xl rounded-br-5xl px-4 md:px-10 py-2 md:py-8 gap-4 md:gap-0 shadow-sm overflow-hidden"
            style={{
              borderTopLeftRadius: "40px",
              borderBottomRightRadius: "40px",
              minHeight: "60px",
            }}
          >
            {/* LCP image — real <img> for fast discovery by browser preload scanner */}
            <img
              src={bgImage}
              alt=""
              // @ts-ignore
              fetchpriority="high"
              decoding="async"
              className="absolute inset-0 w-full h-full object-cover"
              style={{ borderTopLeftRadius: "40px", borderBottomRightRadius: "40px" }}
            />
            <h1 className="relative z-10 breadcrumb text-2xl sm:text-3xl md:text-4xl font-bold text-black dark:text-white mb-2 md:mb-0 tracking-tight leading-tight">
              {pageName}
            </h1>
            <div className="relative z-10 flex flex-col xs:flex-row gap-2 xs:gap-3 w-full md:w-auto justify-start md:justify-end">
              {buttons?.map((btn, idx) => {
                if (btn.href) {
                  return (
                    <Button key={idx} asChild {...btn.props}>
                      <Link href={btn.href}>
                        {btn.icon && <span className="mr-2">{btn.icon}</span>}
                        {btn.label}
                      </Link>
                    </Button>
                  );
                }
                return (
                  <Button key={idx} {...btn.props}>
                    {btn.icon && <span className="mr-2">{btn.icon}</span>}
                    {btn.label}
                  </Button>
                );
              })}
            </div>
          </div>

          <div className="w-full pt-0 md:pt-2 px-1 md:px-0">
            <div className="text-left">
              <ul className="flex flex-wrap items-center gap-2 md:gap-0 text-sm md:text-base">
                <li className="flex items-center">
                  <Link
                    href={parentPage?.href || "/"}
                    className="pr-1 font-medium text-gray-800 hover:text-blue-800 transition-colors duration-150"
                  >
                    {parentPage?.label || t("home")}
                  </Link>
                  <span className="mr-3 block h-2 w-2 rotate-45 border-r-2 border-t-2 border-body-color"></span>
                </li>
                <li className="font-medium hover:text-primary transition-colors duration-150">
                  {breadcrumbName || pageName}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Breadcrumb;
